import { render, staticRenderFns } from "./TextAreaRectangleCoordinatableObjectEditor.vue?vue&type=template&id=8feee5e4&scoped=true&"
import script from "./TextAreaRectangleCoordinatableObjectEditor.vue?vue&type=script&lang=ts&"
export * from "./TextAreaRectangleCoordinatableObjectEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaRectangleCoordinatableObjectEditor.vue?vue&type=style&index=0&id=8feee5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feee5e4",
  null
  
)

export default component.exports